import React from "react";
import ReactGA from "react-ga";
import { Router } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { createBrowserHistory } from "history";
import MomentUtils from "@date-io/moment";
import { Provider as StoreProvider } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider } from 'notistack';
import { I18nextProvider } from 'react-i18next';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import i18next from 'i18next';
import translationResources from './translations';
import { configureStore } from './store';

import 'react-perfect-scrollbar/dist/css/styles.css';
import getRoutes from './routes';
import ZohoHelpDesk from './components/ZohoHelpDesk';
import AssetDrawer from './components/AssetDrawer';
import ScrollReset from './components/ScrollReset';
//- Notification imports
import NotificationsDrawer from './views/NotificationsDrawer';
import { StylesWrapper } from "./components/LayoutComponents/StylesWrapper";

import 'react-quill/dist/quill.snow.css';

// import StylesProvider from './components/StylesProvider';
import "./mixins/chartjs";
import "./mixins/moment";
import "./mixins/validate";
import "./mixins/prismjs";
// import './mock';
import './assets/scss/main.scss';

const history = createBrowserHistory();

function App() {
  //Set up Google Analytics
  let gaConfig =
    process.env.NODE_ENV !== 'production' ? { testMode: true } : {};
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, gaConfig);
  ReactGA.pageview(window.location.pathname + window.location.search);

  //Set up i18next
  i18next.init({
    resources: translationResources,
    fallbackLng: 'en_gb',
    debug: true,
    interpolation: { escapeValue: false }, // React already does escaping
  });

  const store = configureStore();

  return (
    <StoreProvider store={store}>
      <I18nextProvider i18n={i18next}>
        <DndProvider backend={HTML5Backend}>
          <StylesWrapper>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <SnackbarProvider maxSnack={3}>
                <Router history={history}>
                  <ScrollReset />
                  <ZohoHelpDesk />
                  <AssetDrawer />
                  <NotificationsDrawer />
                  {renderRoutes(getRoutes(store))}
                </Router>
              </SnackbarProvider>
            </MuiPickersUtilsProvider>
          </StylesWrapper>
        </DndProvider>
      </I18nextProvider>
    </StoreProvider>
  );
}

export default App;

/* REACT-DND-COPYRIGHT-NOTICE

The MIT License (MIT)

Copyright (c) 2015 Dan Abramov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
